'use client';

// Third Party
import { c as _c } from "react/compiler-runtime";
import cx from 'classnames';
export type IReviewStarsProps = {
  rating: number;
  isSummary?: boolean;
};
export const ReviewStars: React.FC<IReviewStarsProps> = t0 => {
  const $ = _c(7);
  const {
    rating,
    isSummary: t1
  } = t0;
  const isSummary = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== isSummary || $[1] !== rating) {
    const jsx = [];
    for (let i = 0; i < Math.floor(rating); i++) {
      jsx.push(<img alt="full rating star" key={`ystar-${i}`} src="/assets/svg/ratings/star-yellow.svg" className={cx("w-3 h-3", {
        "w-4 h-4": isSummary
      })} />);
    }
    if (rating % 1 !== 0) {
      let t3;
      if ($[3] !== isSummary) {
        t3 = cx("w-3 h-3", {
          "w-4 h-4": isSummary
        });
        $[3] = isSummary;
        $[4] = t3;
      } else {
        t3 = $[4];
      }
      let t4;
      if ($[5] !== t3) {
        t4 = <img alt="partial rating star" key="pstar" src="/assets/svg/ratings/star-yellow-half.svg" className={t3} />;
        $[5] = t3;
        $[6] = t4;
      } else {
        t4 = $[6];
      }
      jsx.push(t4);
    }
    const totalFilledAndHalf = Math.ceil(rating);
    const emptyStarsNeeded = 5 - totalFilledAndHalf;
    for (let j = 0; j < emptyStarsNeeded; j++) {
      jsx.push(<img alt="empty rating star" key={`star-${j}`} src="/assets/svg/ratings/star.svg" className={cx("w-3 h-3", {
        "w-4 h-4": isSummary
      })} />);
    }
    t2 = <div className="flex flex-row">{jsx}</div>;
    $[0] = isSummary;
    $[1] = rating;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};